export default function getItemRightsManagementRestrictions(item) {
    var IRMData = item ? item.RightsManagementLicenseData : null;
    var restrictions = {
        ReplyAllowed: true,
        ReplyAllAllowed: true,
        ForwardAllowed: true,
        PrintAllowed: true,
        CopyAllowed: true,
    };
    if (IRMData &&
        (!IRMData.RightsManagedMessageDecryptionStatus ||
            IRMData.RightsManagedMessageDecryptionStatus == 0 /* Success */)) {
        var ReplyAllowed = IRMData.ReplyAllowed, ReplyAllAllowed = IRMData.ReplyAllAllowed, ForwardAllowed = IRMData.ForwardAllowed, PrintAllowed = IRMData.PrintAllowed, ExtractAllowed = IRMData.ExtractAllowed;
        restrictions = {
            ReplyAllowed: ReplyAllowed,
            ReplyAllAllowed: ReplyAllAllowed,
            ForwardAllowed: ForwardAllowed,
            PrintAllowed: PrintAllowed,
            CopyAllowed: ExtractAllowed,
        };
    }
    // Also consider the 'Do Not Forward' flag if this is a meeting request message
    var meetingRequestMessage = item;
    var doNotForwardMeeting = meetingRequestMessage && meetingRequestMessage.DoNotForwardMeeting;
    restrictions.ForwardAllowed = restrictions.ForwardAllowed && !doNotForwardMeeting;
    return restrictions;
}
//# sourceMappingURL=getItemRightsManagementRestrictions.js.map